import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'clsx';
import { Link } from '@reach/router';

import styles from './PreviousOrdersSection.module.scss';

import { MenuSection } from 'components/MenuSection/MenuSection';
import { useOrderHistory } from 'hooks/context/OrderHistory';

import { PREVIOUS_ORDER_SECTION } from '../const';
import { PreviousOrderCard } from '../PreviousOrderCard/PreviousOrderCard';
import { ShimmerCard } from 'components/ShimmerCard/ShimmerCard';

const PREVIOUS_ORDERS_SIZE = 2;

export const PreviousOrdersSection: FC<React.AllHTMLAttributes<HTMLDivElement>> = ({ className, ...props }) => {
  const { t } = useTranslation();
  const { orders, loading } = useOrderHistory();

  if (!loading && orders.length === 0) return null;

  const showMore = orders.length - PREVIOUS_ORDERS_SIZE > 0;

  return (
    <>
    <MenuSection
      title={t('previousOrder.title')}
      titleTestId={PREVIOUS_ORDER_SECTION.title}
      className={cx(className, { [styles.hasMore]: showMore })}
      shimmer={loading}
      {...props}
    >
      {loading ?
        Array.from(Array(PREVIOUS_ORDERS_SIZE).keys()).map((i) => <ShimmerCard key={i} />) :
        orders.slice(0, PREVIOUS_ORDERS_SIZE).map(order => <PreviousOrderCard key={order.id} order={order} />)
      }
    </MenuSection>
    {showMore &&
      <Link
        to="previous-orders"
        className={styles.moreLink}
        data-testid={PREVIOUS_ORDER_SECTION.moreLink}
      >
        {t('previousOrder.moreOrders', { count: orders.length - PREVIOUS_ORDERS_SIZE })}
      </Link>}
  </>
);
};
